const React = require('react');
const isNode = (typeof process !== 'undefined');
const queryString = isNode ? require('query-string') : {};

const RENTAL_TYPE = 'RENTAL_TYPE';
const PROPERTY_TYPE = 'PROPERTY_TYPE';
const ALL = 'ALL';

const filters = [
    {
        filterType: ALL,
        name: 'Alle'
    },
    {
        filterType: RENTAL_TYPE,
        filter: 'realestate-letting',
        name: 'Leiligheter'
    },
    {
        filterType: RENTAL_TYPE,
        filter: 'realestate-business-letting',
        name: 'Næringseiendom'
    },
    {
        filterType: PROPERTY_TYPE,
        filter: 'garasje-parkering',
        name: 'Garasje'
    }
];

class RentalList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { activeFilterIndex: 0 };
        this.renderRental = this.renderRental.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.getFilterIndex = this.getFilterIndex.bind(this);
    }

    componentDidMount() {
        const parsed = queryString.parse(location.search);
        if (parsed.filter) {
            filters.find((filter, index) => {
                if (filter.filter === parsed.filter) {
                    this.setState({ activeFilterIndex: index });
                    return true;
                }
                return false;
            })
        }
    }

    renderRental(rental) {
        return (
            <div className="rentalList__propertyContainer">
                <div className="rentalList__property">
                    <a className="rentalList__imageContainer" href={rental.link}>
                        <img src={rental.data.listImage}/>
                        {rental.disposed && (<span className="rentalList__disposed">Utleid</span>)}
                    </a>
                    <span className="rentalList__information">
                                    {(rental.data.address) ? (
                                        <h2 className="rentalList__header">{rental.data.address}</h2>
                                    ) : (
                                         <h2 className="rentalList__header">{rental.displayName}</h2>
                                     )}
                                {(rental.data.postalCode && rental.data.city) && rental.data.postalCode + ' ' + rental.data.city}
                        <a href={rental.link}>les mer</a>
                    </span>
                </div>
            </div>
        )
    }

    getFilterIndex(slug) {
        return filters.findIndex(f => f.filter === slug);
    }

    handleFilter(slug) {
        if (isNode) {
            const { history } = window;
            if (slug) {
                history.replaceState('', '', '?filter=' + slug);
                this.setState({ activeFilterIndex: this.getFilterIndex(slug) });
            } else {
                history.replaceState(null, null, window.location.pathname);
                this.setState({ activeFilterIndex: 0 });
            }
        }
    }

    render() {
        const { rentals, introTexts } = this.props;
        const { activeFilterIndex } = this.state;
        const selector = filters[activeFilterIndex];
        const activeIntro = introTexts && introTexts.find(it => it.section === selector.filter);
        return (
            <section className="rentalList">
                <div className="rentalList__container">
                    <ul className="rentalList__filter">
                        {filters.map((filter, i) => <li key={i}><a className={i === activeFilterIndex ? 'active' : ''} onClick={() => this.handleFilter(filter.filter)}>{filter.name}</a></li>)}
                    </ul>

                    {activeIntro && (
                    <div className="rentalIntroduction">
                        <h2 className="rentalIntroduction__title">
                          {activeIntro.title}
                        </h2>
                        <div className="rentalIntroduction__text" dangerouslySetInnerHTML={{__html: activeIntro.intro}} />
                    </div>
                    )}

                    <div className="rentalList__flexContainer">
                        {rentals.filter(rental => {
                            if (selector.filterType === ALL) {
                                return true;
                            }
                            if (selector.filterType === RENTAL_TYPE && rental.data.rentalType === selector.filter) {
                                return true;
                            }
                            if (selector.filterType === PROPERTY_TYPE && rental.typeClasses.indexOf(selector.filter) > -1) {
                                return true;
                            }
                        }).map(rental => this.renderRental(rental))}
                    </div>
                </div>
            </section>
        )
    }
}

module.exports = RentalList;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/rental-list/Component/index.jsx